import React, { Component } from "react";
import './index.css'


export default class Dlg extends Component {

    constructor(props) {
        super(props);
        this.state = {
            value: props.value
        }
    }

      

    closeAlter = () => {
        this.props.onRemoveRoot()
    }

    onCancelClick = () => {
        if (this.props.onCancel) {
            if (this.props.onCancel() === false) {
                return;
            }
        }
        this.closeAlter();
    }

    onCustomClick = () => {
        if (this.props.onCustom) {
            if (this.props.onCustom(this.state.value) === false) {
                return;
            }
        }
        this.closeAlter();
    }

 
    onOkClick = () => {
        if (this.props.onOk) {
            if (this.props.onOk(this.state.value || "",this) === false) {
                return;
            }
        }
        this.closeAlter();
    }

    inputChange = (event) =>{
        this.setState({
            value:event.currentTarget.value
        })
    }

    render() {
        const { height, width, title, placeholder, value, noCancel } = this.props
        return (
            <div className="content" style={{
                width: width ? width : 'auto',
                height: height ? height : 'auto',
            }}>
                <div className="content-body">
                    <div className="title">
                        {title}
                    </div>
                    <div className="content-input">
                        <input type="text" placeholder={placeholder} onChange={this.inputChange} defaultValue={value} value={this.state.value}/>
                    </div>
                    <div className="btn-group">
                        {!noCancel && <div className="cancel-btn GBtn" onClick={this.onCancelClick}>
                            <span>{React.language("cancel")}</span>
                        </div>}
                        <div className="ok-btn GBtn" onClick={this.onOkClick}>
                            <span>{React.language("ok")}</span>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

// Dlg.defaultProps = {
//     okText: React.language("ok"), 
//     onOk:null,
//     cancelText: React.language("cancel"),
//     onCancel:null,
// }